import { useCallback, useState } from 'react';

import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Select, Modal as ModalAntD } from 'antd';
import { T } from 'react-translator-component';

import { CustomOption } from './styled';

import { deleteCompany } from '../../../hooks/company';
import { COLORS } from '../../../utils/theme/colors';

const Modal: any = ModalAntD;

interface Company {
  uuid: string;
  name: string;
  nit: string;
  sap_code: string;
}

interface CompanySelectProps {
  history: any;
  values: any;
  onChange: (value) => void;
  companiesList: Company[];
  onOptionClick: (item) => void;
  getCompaniesData: () => Promise<void>;
  userPk: string;
}

const CompanySelect = ({
  history,
  values,
  companiesList,
  userPk,
  onChange,
  getCompaniesData,
  onOptionClick,
}: CompanySelectProps) => {
  const [dropDownOpen, setDropDownOpen] = useState(false);

  const handleEditCompany = useCallback(
    async (e, uuid, values) => {
      e.stopPropagation();

      history.push(`/company/${uuid}/edit`, {
        isFrom: userPk ? 'edit' : 'create',
        plate: values.firstName,
        id: userPk,
      });
    },
    [history, userPk],
  );

  const handleDeleteCompany = useCallback(
    async (e, item) => {
      e.stopPropagation();

      Modal.confirm({
        title: T('Confirm exclusion'),
        content: (
          <div>
            <p>
              {T('When deleting the Company') +
                ` '${item.name}' ` +
                T(', It will be unlinked from all users')}
            </p>
            <p>{T('Are you sure?')}</p>
          </div>
        ),

        okText: T('Yes'),
        cancelText: T('No'),
        okType: 'danger',
        centered: true,

        onOk: async () => {
          try {
            await deleteCompany(item.uuid);

            onChange(null);

            setTimeout(async () => {
              await getCompaniesData();
            }, 100);

            Modal.success({
              content: T('Company deleted successfully'),
            });
          } catch {
            Modal.error({ content: T('Error deleting the Company') });
          }
        },
      });
    },
    [getCompaniesData, onChange],
  );

  return (
    <Select
      open={dropDownOpen}
      style={{ width: 320 }}
      value={values?.company?.name}
      onChange={onChange}
      onDropdownVisibleChange={(flag) => setDropDownOpen(flag)}
      dropdownRender={() => (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ maxHeight: 200, overflowY: 'auto' }}>
            {companiesList &&
              companiesList.map((item) => (
                <CustomOption
                  key={item.uuid}
                  onClick={() => {
                    setDropDownOpen(false);

                    onOptionClick(item);
                  }}
                >
                  <span className='optionText'>{item.name}</span>
                  <div className='actions'>
                    <Button
                      icon={<EditOutlined />}
                      size='small'
                      style={{ marginRight: 4 }}
                      onClick={(e) => handleEditCompany(e, item.uuid, values)}
                    />
                    <Button
                      icon={<DeleteOutlined />}
                      size='small'
                      danger
                      onClick={(e) => handleDeleteCompany(e, item)}
                    />
                  </div>
                </CustomOption>
              ))}
          </div>

          <div>
            <Button
              type='link'
              icon={<PlusOutlined />}
              block
              style={{ color: COLORS.primary }}
              onClick={() => {
                history.push('/company/create', {
                  isFrom: userPk ? 'edit' : 'create',
                  plate: values.firstName,
                  id: userPk,
                });
              }}
            >
              Adicionar empresa
            </Button>
          </div>
        </div>
      )}
    />
  );
};

export default CompanySelect;
